import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { backgroundWithBorderPalettes, type ScanToPayPalette } from '../../utils';

export const ScanToPayBottomCard = (props: ScanToPayBottomCardProps) => {
  const { children, palette } = props;

  return <View style={[styles.container, backgroundWithBorderPalettes[palette]]}>{children}</View>;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayBottomCardProps = {
  children: PropsWithChildren['children'];
  palette: ScanToPayPalette;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    borderRadius: theme.radius.large,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    gap: theme.spacing['6'],
    padding: theme.spacing['6'],
    marginBottom: theme.spacing['24'],
    marginTop: 'auto',
  },
});
